import { render } from "./SoyezSages.vue?vue&type=template&id=4e67fd9c"
import script from "./SoyezSages.vue?vue&type=script&lang=js"
export * from "./SoyezSages.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__